export const CLIENT_LOGIN_URL = 'https://www.portal.versalaunch.com';

export const servicesMenuColumns = [
  {
    title: 'Core Website Essentials',
    links: [
      { label: 'Custom Design', to: '/services/custom-design' },
      { label: 'Client Portals & Forms', to: '/services/client-portals' },
      { label: 'Web Apps', to: '/services/web-apps' }
    ]
  },
  {
    title: 'Business Growth',
    links: [
      { label: 'AI Phone Assistant', to: '/services/ai-phone-assistant' },
      { label: 'Business Phone Line', to: '/services/business-phone' },
      { label: 'Rewards Program', to: '/services/rewards' },
      { label: 'Square Integrations', to: '/services/square-integrations' }
    ]
  },
  {
    title: 'Explore',
    links: [
      { label: 'All Services', to: '/services' },
      { label: 'Pricing', to: '/plans' },
      { label: 'Client Login', href: CLIENT_LOGIN_URL, external: true }
    ]
  }
];

export const resourcesMenuColumns = [
  {
    title: 'Start Here',
    links: [
      { label: 'All Resources', to: '/resources' },
      { label: 'Getting Started Guide', to: '/resources/getting-started' },
      { label: 'Best Practices Playbook', to: '/resources/best-practices' }
    ]
  },
  {
    title: 'Growth Library',
    links: [
      { label: 'Marketing Strategies', to: '/resources/marketing-strategies' },
      { label: 'SEO for Your Business', to: '/resources/seo-guide' },
      { label: 'Portfolio', to: '/portfolio' },
      { label: 'Case Studies', to: '/resources/case-studies' },
      { label: 'Growth Tips', to: '/resources/growth-tips' }
    ]
  },
  {
    title: 'Company',
    links: [
      { label: 'Careers', to: '/careers' }
    ]
  }
];

export const resourcesFeatured = {
  imageSrc: '/images/Overlookiung-PC.jpg',
  imageAlt: 'Versa Launch resources',
  kicker: 'Versa Launch Resources',
  description: 'Clean, practical guides to get more leads, appointments, and repeat customers.',
  ctaLabel: 'Explore Resource Hub ->',
  ctaTo: '/resources'
};
